<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div>
    <el-form label-width="80px" class="">
      <el-row>
        <el-col :span="6">
          <el-form-item label="编码" prop="">
            <el-input v-model="query.cvcode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="名称" prop="">
            <el-input v-model="query.cvname"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="类型" prop="">
            <el-select v-model="query.cvtype" :clearable="true" >
              <el-option v-for="(item, index) in cvtypeList" :label="item.label" :value="item.value" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button icon="search" @click="getPageList">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange"></vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'cvIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'cvcode', fieldtype: 'C', title: '编码',calculExpr:'', addNewRowFlg: false},
          { field: 'cvname', fieldtype: 'C', title: '名称',calculExpr:'',addNewRowFlg: false},
          { field: 'cvtype', fieldtype: 'C', title: '类型',calculExpr:'',addNewRowFlg: false},
          { field: 'cvcontact', fieldtype: 'C', title: '联系人',calculExpr:'',addNewRowFlg: false},
          { field: 'cvtel', fieldtype: 'C', title: '联系电话',calculExpr:'',addNewRowFlg: false},
          { field: 'cvaddr', fieldtype: 'C', title: '联系地址',calculExpr:'',addNewRowFlg: false},
          { field: 'cvremark', fieldtype: 'C',title: '备注',calculExpr:'',addNewRowFlg: false}
        ],
        cv: {},
        cvtypeList: [],
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addCv())
      this.$on('CHG', () => this.chgCv())
      this.$on('DEL', () => this.delCv())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getCvtype()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
//      async '$route' (to,from) {
//        if (from.name === 'cvForm') {
//          this.getPageList()
//        }
//      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async getCvtype () {
        let cvtypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'cvtype'}
        })
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addCv () {
        let form = {
          cvid: 0
        }
        console.log(this.$router)
        this.$router.push({name: 'cvForm', params: {form: form, type: 1}})
      },
      async chgCv () {
        this.$router.push({name: 'cvForm', params: {form: this.cv, type: 2}})
      },
      async delCv () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/basic/cv/delCv',
            method: "post",
            data: this.cv
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      handleSizeChange (val) {
        this.query.pageSize = val
        this.getPageList()
      },
      handleCurrentChange (val) {
        this.offset = val
        this.getPageList()
      },
      async cellClick (row) {
        this.cv = row.row
      },
      async pagechange (cvPage) {
        this.query.offset = cvPage.pageSize * (cvPage.currentPage - 1)
        this.query.limit = cvPage.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/basic/cv/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
